import RoutesMap from "route_control/RouteControl"
import { CountryList, StateList, CityList, CategoryList, UnitList, PincodeList } from "pages/master"

const MasterRoute = () => {
    return [
        {
            path: RoutesMap.COUNTRY_LIST.path,
            element: <CountryList />
        },

        {
            path: RoutesMap.STATE_LIST.path,
            element: <StateList />
        },

        {
            path: RoutesMap.CITY_LIST.path,
            element: <CityList />
        },

        {
            path: RoutesMap.CATEGORY_LIST.path,
            element: <CategoryList />
        },

        {
            path: RoutesMap.UNIT_LIST.path,
            element: <UnitList />
        },

        {
            path: RoutesMap.PINCODE_LIST.path,
            element: <PincodeList />
        },

    ]
}

export default MasterRoute;